import { api } from '@/lib/api-client';
import { adventurer } from '@dicebear/collection';
import { createAvatar } from '@dicebear/core';
import { usePrivy } from '@privy-io/react-auth';
import { useCallback } from 'react';

function generateRandomName() {
  const adjectives = [
    'Happy',
    'Brave',
    'Clever',
    'Swift',
    'Bright',
    'Calm',
    'Eager',
    'Fierce',
    'Gentle',
    'Kind',
  ];
  const nouns = [
    'Panda',
    'Tiger',
    'Eagle',
    'Dolphin',
    'Wolf',
    'Lion',
    'Fox',
    'Bear',
    'Hawk',
    'Deer',
  ];

  const randomAdjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const randomNoun = nouns[Math.floor(Math.random() * nouns.length)];
  const randomNumber = Math.floor(Math.random() * 1000);

  return `${randomAdjective}${randomNoun}${randomNumber}`;
}

async function generateProfilePicture(seed: string) {
  const avatar = createAvatar(adventurer, {
    seed,
    size: 128,
  });

  return avatar.toDataUri();
}

export function useCreateUser() {
  const { user } = usePrivy();

  const createUserIfNeeded = useCallback(async () => {
    if (!user) return;

    try {
      const profilePicture = await generateProfilePicture(user.id);

      await api.createUser({
        user_id: user.id,
        profile_picture: profilePicture,
        name: generateRandomName(),
      });
    } catch (error) {
      console.error('Failed to create user:', error);
      throw error;
    }
  }, [user]);

  return { createUserIfNeeded };
}
